/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Reauthentication_RequiredInputs */

const en_error_reauthentication_required = /** @type {(inputs: Error_Reauthentication_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To change how you sign in, enter your password again.`)
};

/**
* | output |
* | --- |
* | "To change how you sign in, enter your password again." |
*
* @param {Error_Reauthentication_RequiredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_reauthentication_required = /** @type {((inputs?: Error_Reauthentication_RequiredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Reauthentication_RequiredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_reauthentication_required(inputs)
});